var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVaricentlogo = function SvgVaricentlogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "varicentlogo_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 144 144"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".varicentlogo_svg__st1{clip-path:url(#varicentlogo_svg__SVGID_4_)}.varicentlogo_svg__st13{clip-path:url(#varicentlogo_svg__SVGID_28_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_1_",
    d: "M3.8 21.5h55.8v47.7H3.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_2_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_3_",
    d: "M3.8 20.6h56.7v49.2H3.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "varicentlogo_svg__st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_5_",
    d: "M33.4 54.4c0 8.2-6.6 14.8-14.8 14.8S3.8 62.6 3.8 54.4s6.6-14.8 14.8-14.8 14.8 6.6 14.8 14.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_6_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_7_",
    d: "M3.8 20.6h56.7v49.2H3.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-15.1 20.7h67.4v67.4h-67.4z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_8_)",
      fill: "#2b4ff4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "varicentlogo_svg__st1"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_9_",
    d: "M59.6 34.5c0 7.2-5.9 13.1-13.1 13.1s-13.1-5.9-13.1-13.1 5.9-13.1 13.1-13.1c7.2.1 13.1 5.9 13.1 13.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_10_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_11_",
    d: "M3.8 20.6h56.7v49.2H3.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5h64v64h-64z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_12_)",
      fill: "#2b4ff4"
    }
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_13_",
    d: "M59 74.5c0 7.5-6.1 13.7-13.7 13.7-7.5 0-13.7-6.1-13.7-13.7s6.1-13.7 13.7-13.7S59 66.9 59 74.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_14_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_15_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 41.9h65.1V107H12.8z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_16_)",
      fill: "#2b4ff4"
    }
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_17_",
    d: "M81.4 54c0 6.6-5.4 11.9-12 11.9s-12-5.3-12-11.9 5.4-11.9 12-11.9c6.7-.1 12 5.3 12 11.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_18_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_19_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6 23.1h61.7v61.7H38.6z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_20_)",
      fill: "#2b4ff4"
    }
  })), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_21_",
    d: "M82.7 93.1c0 6.9-5.6 12.5-12.5 12.5S57.7 100 57.7 93.1s5.6-12.5 12.5-12.5 12.5 5.6 12.5 12.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_22_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_23_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 61.7h62.9v62.9H38.7z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_24_)",
      fill: "#2b4ff4"
    }
  })), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_25_",
    d: "M79.9 61.2h24.6v60.5H79.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_26_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_27_",
    d: "M79.5 58.4H106v64.3H79.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "varicentlogo_svg__st13"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_29_",
    d: "M101.5 72c0 6-4.8 10.8-10.8 10.8S79.9 78 79.9 72s4.8-10.8 10.8-10.8c5.9 0 10.8 4.8 10.8 10.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_30_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_31_",
    d: "M79.5 58.4H106v64.3H79.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61 42.2h59.5v59.4H61z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_32_)",
      fill: "#2b4ff4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "varicentlogo_svg__st13"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_33_",
    d: "M104.5 110.3c0 6.3-5.1 11.4-11.4 11.4s-11.4-5.1-11.4-11.4 5.1-11.4 11.4-11.4c6.3.1 11.4 5.1 11.4 11.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_34_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_35_",
    d: "M79.5 58.4H106v64.3H79.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 80h60.6v60.6H62.8z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_36_)",
      fill: "#2b4ff4"
    }
  })))), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_37_",
    d: "M118.1 89.9c0 5.3-4.3 9.7-9.7 9.7-5.3 0-9.7-4.3-9.7-9.7 0-5.3 4.3-9.7 9.7-9.7 5.3 0 9.7 4.3 9.7 9.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_38_)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_39_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.8 61.3H137v57.2H79.8z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_40_)",
      fill: "#2b4ff4"
    }
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_41_",
    d: "M115.9 55.5c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c4.5 0 8 3.6 8 8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_42_)"
    }
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_43_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.1 28.6h53.8v53.8H81.1z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_44_)",
      fill: "#2b4ff4"
    }
  })), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_45_",
    d: "M129.6 72.1c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c4.5 0 8 3.6 8 8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_46_)"
    }
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_47_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.8 45.2h53.8V99H94.8z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_48_)",
      fill: "#2b4ff4"
    }
  })), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_49_",
    d: "M128.9 41.9c0 3.8-3.1 6.8-6.8 6.8-3.8 0-6.8-3.1-6.8-6.8 0-3.8 3.1-6.8 6.8-6.8s6.8 3 6.8 6.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_50_)"
    }
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_51_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.3 16.1h51.5v51.5H96.3z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_52_)",
      fill: "#2b4ff4"
    }
  })), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_53_",
    d: "M139.8 57.2c0 3.8-3.1 6.8-6.8 6.8-3.8 0-6.8-3.1-6.8-6.8 0-3.8 3.1-6.8 6.8-6.8s6.8 3 6.8 6.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_54_)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "varicentlogo_svg__SVGID_55_",
    d: "M-90.8-47.5h5447.4v3064.1H-90.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "varicentlogo_svg__SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#varicentlogo_svg__SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.2 31.5h51.5V83h-51.5z",
    style: {
      clipPath: "url(#varicentlogo_svg__SVGID_56_)",
      fill: "#2b4ff4"
    }
  })));
};
export { SvgVaricentlogo as ReactComponent };
export default new URL("/codebuild/output/src3860153836/src/src/assets/svgs/varicentlogo.svg", import.meta.url).toString();